
export default function locationAssign (url) {
    const appStore = this.env.appStore;
    if (appStore.flags.embedded) {
        this.notifyClientPage({
            action: 'locationAssign',
            data: {
                url,
            },
        });
    } else {
        window.location.assign(url);
    }
}
